import http from '@/utils/http'
import httpApi from '@/apis/httpApi'

export const agreementSecurity = (data) => {
  return http.get({
    url: httpApi.agreement.agreementSecurity,
    data
  })
}
export const queryAgreementSecurity = (data) => {
  return http.get({
    url: httpApi.agreement.queryAgreementSecurity,
    data
  })
}
export const switchClientHafman = (data) => {
  return http.get({
    url: httpApi.debugModel.switchClientHafman,
    data
  })
}
export const getSupportInfo = (data) => {
  return http.get({
    url: httpApi.agreement.getSupportInfo,
    data
  })
}
